(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
function initializeWheelGalleries(root) {
  root.querySelectorAll('[data-wheel-gallery]').forEach(gallery => {
    if (gallery.dataset.ready) return;
    gallery.dataset.ready = 'true';
    const track = gallery.querySelector('.wheel-gallery-track');
    if (!track) return;
    const slides = Array.from(track.children);
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const count = gallery.querySelector('[data-gallery-count]');
    const previous = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const current = () => Math.round(track.scrollLeft / track.clientWidth);
    const go = index => track.scrollTo({left: slides[Math.max(0, Math.min(slides.length - 1, index))].offsetLeft - slides[0].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    const update = () => {
      const index = current();
      if (count) count.textContent = (index + 1) + ' / ' + slides.length;
      thumbs.forEach((thumb, i) => {
        if (i === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    };
    if (previous) previous.addEventListener('click', () => go(current() - 1));
    if (next) next.addEventListener('click', () => go(current() + 1));
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', event => {event.preventDefault(); go(index);}));
    track.addEventListener('scroll', update, {passive:true});
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        go(current() + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    update();
  });
}
initializeWheelGalleries(document);
document.addEventListener('shopify:section:load', event => initializeWheelGalleries(event.target));

  } catch(e) { console.error(e); }
})();
})();
